module.exports = __webpack_public_path__ + "static/media/outside4.6facd0ea.png";